import React, { useEffect, useState, useRef } from 'react'
import './index.less'
import {
  getParamsFromHash
} from '../../../../utils/common'

import { getCurrentUid } from '../../../../api/web-h5-common'
import {
  GetMemberGoods
} from '../../api'

const App = () => {
  const queryTitle = getParamsFromHash('title')
  const title = queryTitle ? decodeURIComponent(queryTitle) : ''
  const uid = useRef('')
  const [agreementUrl, setAgreementUrl] = useState('')

  useEffect(() => {
    document.title = title || '小鹏充电VIP用户协议'

    getCurrentUid().then(userId => {
      uid.current = userId
      initData()
    }).catch(err => {
      console.log('getCurrentUid error --> ', err)
    })
  }, [])

  const initData = async () => {
    try {
      getMemberGoods()
    } catch (error) {
      console.log('initData error -->', error)
    }
  }

  const getMemberGoods = async () => {
    try {
      const res: any = await GetMemberGoods()
      if (res.code === 200) {
        setAgreementUrl(res?.data?.agreementUrl)
      } else {
        // no need handle
      }
    } catch (error) {
      console.log('getMemberGoods error -->', error)
    }
  }

  return (
    <div className='charge-vip-agreement'>
      <div className='content'>
        <img alt='' className='image' src={agreementUrl} />
      </div>
    </div>
  )
}

export default App